import MuiAvatar from "@mui/material/Avatar";
const Avatar = MuiAvatar;
export default Avatar;
